/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { Button, message, Modal, Spin } from "antd";
import { useReactToPrint } from "react-to-print";
import crossButton from "../../assests/images/CrossButton.svg";

import Dox from "./Dox/index.jsx";
// import NonDox from "./NonDox/index.jsx";
import "./style.scss";
import "../../commonStyles/crossButton.scss";
import urls from "../../api/urls.js";
import API from "../../api/index.js";
// let date = new Date().toLocaleString(undefined, { timeZone: "Asia/Kolkata" });
const ViewBookingSummary = ({
  visible,
  handleCancel = () => {},
  allAppData,
  bookingType,
  loading,
  creditCharges,
}) => {
  // const summaryDate = allAppData?.bookingTime?.split(" ", 1)[0];
  // const [loading, setLoading] = useState(false);

  // console.log(allAppData, "ALL");

  return (
    <div>
      <Modal
        title="Booking Summary :"
        className="booking-summary"
        open={visible}
        width={1000}
        footer={false}
        onCancel={handleCancel}
        maskClosable={false}
        closeIcon={<img src={crossButton} />}
      >
        <Spin spinning={loading}>
          <div style={{ margin: "0 10px" }}>
            {/* <span onClick={printHandle}>PRINT</span> */}

            <Dox
              allAppData={allAppData}
              creditCharges={creditCharges}
              // summaryDate={summaryDate}
              // componentRef={componentRef}
              bookingType={bookingType}
            />
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

// BookingSummary.propTypes = {
//   second: PropTypes.third,
// };

export default ViewBookingSummary;
